module.exports = __webpack_public_path__ + "static/media/stamp.38099f28.svg";